// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1897":"0827a8bf","1978":"89966a7c","2141":"03b22751","2726":"28d02cff","3971":"603bf42f","6663":"dae9863d","7811":"603bf42f","8294":"603bf42f"}[chunkId] + ".chunk.css";
};